import { API_BASE } from '@/lib/apiBase';
import { useParams } from 'react-router-dom';

export function apiBase(): string {
  return API_BASE;
}

/** Always returns exactly one '/api' segment; normalizes double slashes. */
export function buildApiUrl(path: string): string {
  const base = (API_BASE || '').replace(/\/+$/, '');
  let p = (path || '').startsWith('/') ? path : `/${path}`;

  const baseHasApi = /\/api$/.test(base);
  const pathHasApi = /^\/api(\/|$)/.test(p);

  if (baseHasApi && pathHasApi) p = p.replace(/^\/api(\/|$)/, '/');
  else if (!baseHasApi && !pathHasApi) p = `/api${p}`;

  return `${base}${p}`.replace(/([^:]\/)\/+/g, '$1');
}

/** Returns just the '/api/...' path portion (useful for routers). */
export function buildApiPath(path: string): string {
  const url = buildApiUrl(path);
  const i = url.indexOf('/api/');
  return i >= 0 ? url.slice(i) : '/api';
}

export function useTenantHeaders() {
  const { subdomain } = useParams();
  const slug = (subdomain || localStorage.getItem('tenantSlug') || 'demo') as string;
  return { 'X-Tenant': slug };
}
